export type InfoType = 'primary' | 'secondary' | 'success' | 'danger' | 'xdanger' | 'warning' | 'info' | 'light' | 'dark' | 'link' | 'custom';
export type BadgeStyle = { bg: string, text: string };
export const badgeStyle: Record<InfoType, BadgeStyle> = {
    info: {bg: "bg-gray-100", text: "text-gray-800"},
    danger: {bg: "bg-red-100", text: "text-red-800"},
    xdanger: {bg: "bg-red-600", text: "text-white"},
    warning: {bg: "bg-yellow-100", text: "text-yellow-800"},
    success: {bg: "bg-green-100", text: "text-green-800"},
    primary: {bg: "bg-blue-100", text: "text-blue-800"},
    secondary: {bg: "bg-indigo-100", text: "text-indigo-800"},
    light: {bg: "bg-purple-100", text: "text-purple-800"},
    dark: {bg: "bg-pink-100", text: "text-pink-800"},
    link: {bg: "bg-blue-100", text: "text-blue-800"},
    custom: {bg: "", text: ""},
};
const BasicBadge: React.FC<{ label: string | number | undefined, type: InfoType, textClass?: string, customStyle?: BadgeStyle }> = ({
                                                                                                                                        label,
                                                                                                                                        type,
                                                                                                                                        textClass = 'text-xs',
                                                                                                                                        customStyle = badgeStyle[type]
                                                                                                                                    }) => {
    return (<>
            {label &&
                <span className={`inline-flex items-center rounded-full ${customStyle.bg} px-2.5 py-0.5 ${textClass} font-medium ${customStyle.text}`}>
        {label}
      </span>
            }</>
    )
}
export default BasicBadge;
